exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-disable{\n    pointer-events: none;\n}", ""]);

// exports
